import { render } from "./TreeControl.vue?vue&type=template&id=f979f164&scoped=true&ts=true"
import script from "./TreeControl.vue?vue&type=script&lang=ts"
export * from "./TreeControl.vue?vue&type=script&lang=ts"

import "./TreeControl.vue?vue&type=style&index=0&id=f979f164&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f979f164"]])

export default __exports__